export default __webpack_public_path__ + "static/media/GelBoxFull.d7095c4d.svg";